import { render, staticRenderFns } from "./MatchQuestionList.vue?vue&type=template&id=6b777016"
import script from "./MatchQuestionList.vue?vue&type=script&lang=js"
export * from "./MatchQuestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports